import StoryblokClient from 'storyblok-js-client'

export default new StoryblokClient({
  accessToken: import.meta.env.VITE_STORYBLOK_TOKEN,
  region: 'eu',
  cache: {
    type: 'none',
  },
})
